const t={left:-.5,top:-.5,center:0,bottom:.5,right:.5},o=o=>"string"==typeof o?t[o]:o-.5;export{o as resolveOrigin};
//# sourceMappingURL=resolveOrigin.min.mjs.map
